import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const CopyIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><path d="M21 3H7v14h14V3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M17 17v4H3V7h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default CopyIcon;